@use "variables" as *;

.content {
  display: flex;
  flex-direction: column;
}

.message {
  font-size: $fontSize-s;
  margin-bottom: $spacing-m;
}

.toolbarBox {
  flex-shrink: 0;
}
